/* eslint-disable */
export let swSignalClient = null;

export let localStore = new LS();

function Observable() {
  (this.observers = []),
    (this.subscribe = function (func) {
      this.observers.push(func);
    }),
    (this.unsubscribe = function (func) {
      this.observers = this.observers.filter((observer) => {
        if (observer !== func) return observer;
      });
    }),
    (this.emit = function (event, data) {
      this.observers.forEach((func) => func(event, data));
    }),
    (this.destroy = function () {
      this.observers = [];
    });
}
function LS() {
  (this.observers = new Observable()),
    (this.subscribe = function (func) {
      this.observers.subscribe(func);
    }),
    (this.unsubscribe = function (func) {
      this.observers.unsubscribe(func);
    }),
    (this.loggedIn = !1),
    (this.exmAddress = ""),
    (this.exmParams = {}),
    (this.metaData = {}),
    (this.viewerOptions = {}),
    (this.remotePeers = new Map()),
    (this.activeStreams = new Map()),
    (this.transceivers = new Map()),
    (this.transceiverPairs = 0),
    (this.talkbackTransceivers = new Map()),
    (this.talkbackAudioTrack = null),
    (this._talkbackDummyAudioTrack = (() => {
      let ctx = new AudioContext(),
        oscillator = ctx.createOscillator(),
        dst = oscillator.connect(ctx.createMediaStreamDestination());
      return (
        oscillator.start(),
        Object.assign(dst.stream.getAudioTracks()[0], { enabled: !1 })
      );
    })()),
    (this.talkbackCounters = new Map()),
    (this.talkbackWaitList = new Map()),
    (this._audioSyncTimerID = null),
    (this.getLoggedIn = function () {
      return this.loggedIn;
    }),
    (this.setLoggedIn = function (value) {
      (this.loggedIn = value), this.observers.emit("loggedIn", this.loggedIn);
    }),
    (this.setExmAddress = function (exmAddress) {
      (this.exmAddress = exmAddress),
        this.observers.emit("exmAddress", this.exmAddress);
    }),
    (this.getExmAddress = function () {
      return this.exmAddress;
    }),
    (this.setExmParams = function (exmParams) {
      (this.exmParams = exmParams),
        this.observers.emit("exmParams", this.exmParams);
    }),
    (this.getExmParams = function () {
      return this.exmParams;
    }),
    (this.setMetaData = function (metaData) {
      (this.metaData = metaData),
        this.observers.emit("setMetaData", this.metaData);
    }),
    (this.getMetaData = function () {
      return this.metaData;
    }),
    (this.setViewerOptions = function (viewerOptions) {
      (this.viewerOptions = viewerOptions),
        this.observers.emit("viewerOptions", this.viewerOptions);
    }),
    (this.getViewerOptions = function () {
      return this.viewerOptions;
    }),
    (this.clearRemotePeers = function () {
      this.remotePeers.forEach((peer, clientId, map) => {
        peer.peerSession &&
          null !== peer.peerSession &&
          peer.peerSession.destroy();
      }),
        this.remotePeers.clear();
    }),
    (this.setTalkbackAudioTrack = function (_audioTrack) {
      if (!(_audioTrack instanceof MediaStreamTrack))
        throw new Error(
          "setTalkbackAudioTrack : parameter not a MediaStreamTrack."
        );
      if ("audio" === !_audioTrack.kind)
        throw new Error("setTalkbackAudioTrack : parameter not an audiotrack.");
      null === this.talkbackAudioTrack
        ? (this.talkbackAudioTrack = _audioTrack)
        : console.warn(
            "setTalkbackAudioTrack : audioTrack already set previously.  Ignoring."
          );
    }),
    (this.addRemotePeer = function (remotePeer, notify = !0) {
      this.remotePeers.has(remotePeer.clientid)
        ? console.error(
            `LocalStore.removeRemotePeer : Remote Peer with clientid=${remotePeer.clientid} already exists!`
          )
        : (console.log(
            `LocalStore.addRemotePeer : \n    peer.clientid = ${remotePeer.clientid} \n    peer.email = ${remotePeer.email}`
          ),
          this.remotePeers.set(remotePeer.clientid, remotePeer),
          notify &&
            this.observers.emit(
              "discoveredPeer",
              this.remotePeers.get(remotePeer.clientid)
            ));
    }),
    (this.removeRemotePeer = function (remotePeer, notify = !0) {
      const { clientid: clientid, email: email } = remotePeer;
      if (
        (console.log(
          `LocalStore.removeRemotePeer : \n    peer.clientid = ${clientid} \n    peer.email = ${email}`
        ),
        this.remotePeers.has(clientid))
      ) {
        const _peer2bRemoved = this.remotePeers.get(clientid);
        void 0 !== _peer2bRemoved.peerSession &&
          (console.log(`Terminating active P2P session of Peer (${clientid})`),
          _peer2bRemoved.peerSession &&
            null !== _peer2bRemoved.peerSession &&
            _peer2bRemoved.peerSession.destroy()),
          this.remotePeers.delete(clientid),
          notify && this.observers.emit("deletedPeer", remotePeer);
      }
    }),
    (this.setPeerSession = function (remotePeer, peerSession, notify = !0) {
      console.debug("setPeerSession");
      const { clientid: clientid } = remotePeer;
      if (this.remotePeers.has(clientid)) {
        (this.remotePeers.get(clientid).peerSession = peerSession),
          notify && this.observers.emit("setPeerSession", remotePeer);
      } else
        console.error(
          `LocalStore.removePeerSession : Remote Peer with clientid=${clientid} not found!`
        );
    }),
    (this.removePeerSession = function (remotePeer, notify = !0) {
      console.debug("removePeerSession");
      const { clientid: clientid } = remotePeer;
      if (this.remotePeers.has(clientid)) {
        let peer = this.remotePeers.get(clientid);
        peer.peerSession &&
          null !== peer.peerSession &&
          (peer.peerSession.destroy(), (peer.peerSession = null)),
          this.talkbackTransceivers.has(clientid) &&
            (console.log(`Removing transceiver mapping for ${clientid}`),
            this.talkbackTransceivers.delete(clientid)),
          notify && this.observers.emit("removedPeerSession", remotePeer);
      } else
        console.warn(
          `LocalStore.removePeerSession : Remote Peer with clientid=${clientid} not found!`
        );
    }),
    (this.setPeerFeature = function (remotePeer) {
      this.observers.emit("peerFeature", remotePeer);
    }),
    (this.getRemotePeer = function (clientid) {
      return this.remotePeers.get(clientid);
    }),
    (this.notifyDisconnectEXM = function (reason) {
      this.observers.emit("disconnectedFromExm", { reason: reason });
    }),
    (this.notifyPeerData = async function (remotePeer, data) {
      console.debug("notifyPeerData");
      const payload = String.fromCharCode.apply(null, data);
      try {
        const payloadJSON = JSON.parse(payload);
        if ((console.log(payloadJSON), payloadJSON.command))
          if ("talkbackRequest" === payloadJSON.command)
            await this._handleTalkbackRequest(remotePeer.clientid, payloadJSON);
          else console.log(`peerData command=${payloadJSON.command} received.`);
      } catch (error) {
        console.warn(
          `notifyPeerData: Data from remote peer ${remotePeer} is not JSON format.`
        );
      }
      // notify that can play stream on iframe
      this.observers.emit("streamPeerReady", true);
      this.observers.emit("peerData", { remotePeer: remotePeer, data: data });
    }),
    (this._handleTalkbackRequest = async function (clientid, data) {
      const {
        code: code,
        command: command,
        description: description,
        peerId: peerId,
      } = data;
      if (0 === code)
        if (this.talkbackWaitList.has(clientid)) {
          console.log(
            "PeerData - talkbackRuest - accepted!  Sending audio stream to remote peer."
          );
          const streamName = this.talkbackWaitList.get(clientid);
          this.talkbackWaitList.delete(clientid),
            await this._sendAudio(clientid, streamName);
        } else
          console.error(
            `PeerData - talkbackRequest - ClientID (${clientid}) not found in talkbackwaitlist.`
          );
      else
        console.warn(
          `_handleTalkbackRequest - ClientID (${clientid}) rejected. ${description}.`
        );
    }),
    (this.notifyPeerAvailable = function (remotePeer, available) {
      console.debug("notifyPeerAvailable"),
        this.observers.emit("peerAvailability", {
          remotePeer: remotePeer,
          available: available,
        });
    }),
    (this.notifyTalkbackAvailable = function (remotePeer, available) {
      this.observers.emit("talkbackAvailability", {
        remotePeer: remotePeer,
        available: available,
      });
    }),
    (this.notifyPeerConnectionRequest = function (remotePeer, data) {
      this.observers.emit("peerConnectionRequest", {
        remotePeer: remotePeer,
        data: data,
      });
    }),
    (this.notifyPeerConnected = function (remotePeer) {
      this.observers.emit("startPeerSession", { remotePeer: remotePeer });
    }),
    (this.setStreamList = function (remotePeer, streamList, notify = !0) {
      console.debug("setStreamList");
      const { clientid: clientid } = remotePeer;
      if (this.remotePeers.has(clientid)) {
        let peerRecord = this.remotePeers.get(clientid);
        (peerRecord.streams = [...streamList]),
          console.log("LocalStore.setStreamList: "),
          console.table(peerRecord.streams),
          notify &&
            this.observers.emit(
              "setStreamList",
              this.remotePeers.get(clientid)
            );
      }
    }),
    (this.setPeerList = function (data) {
      this.observers.emit("discovery", data);
    }),
    (this.addStreamToList = function (remotePeer, streamName, notify = !0) {
      console.debug("addStreamToList");
      const { clientid: clientid } = remotePeer;
      if (this.remotePeers.has(clientid)) {
        let peerRecord = this.remotePeers.get(clientid);
        console.log(`LocalStore.addStreamToList: ${streamName}`),
          peerRecord.streams.push(streamName),
          notify &&
            this.observers.emit("addStreamToList", {
              clientid: clientid,
              streamName: streamName,
            });
      }
    }),
    (this.removeStreamFromList = function (
      remotePeer,
      streamName,
      notify = !0
    ) {
      console.debug("removeStreamFromList");
      const { clientid: clientid } = remotePeer;
      if (this.remotePeers.has(clientid)) {
        let peerRecord = this.remotePeers.get(clientid);
        peerRecord.streams = peerRecord.streams.filter(
          (checkName) => checkName !== streamName
        );
        const key = `${clientid}${streamName}`;
        this.activeStreams.has(key) &&
          (console.log(
            `removeStreamFromList : Removing orphaned active stream (${key}), firing 'removeActiveStream`
          ),
          this.removeActiveStream(peerRecord, streamName)),
          notify &&
            this.observers.emit("removeStreamFromList", {
              clientid: clientid,
              streamName: streamName,
            });
      }
    }),
    (this.clearActiveStreams = function () {
      console.debug("clearActiveStreams"),
        this.remotePeers.forEach((peer, clientId, map) => {
          peer?.streams &&
            peer.streams.forEach((streamName) => {
              const streamKey = `${clientId}${streamName}`;
              this.activeStreams.has(streamKey) &&
                (console.log(`clearActiveStreams: shutting down ${streamKey}`),
                peer.peerSession.send(`remove:${streamName}`));
            });
        }),
        this.activeStreams.clear();
    }),
    (this._getAudioTrackIDs = function (srcObject) {
      return srcObject.getAudioTracks().map((_track) => _track.id);
    }),
    (this._getVideoTrackIDs = function (srcObject) {
      return srcObject.getVideoTracks().map((_track) => _track.id);
    }),
    (this.addActiveStream = function (
      remotePeer,
      streamName,
      srcObject,
      notify = !0
    ) {
      console.debug("addActiveStream");
      const { clientid: clientid, email: email } = remotePeer,
        streamKey = `${clientid}${streamName}`;
      if (this.activeStreams.has(streamKey))
        if (null !== this._audioSyncTimerID) {
          console.log(
            `LocalStore.addActiveStream new MediaStream object for '${streamKey}' received!`
          );
          const _oldActiveStream = this.activeStreams.get(streamKey);
          console.log("Muting old audio tracks:"),
            console.log(_oldActiveStream.trackIDs),
            srcObject.getAudioTracks().forEach((_audioTrack) => {
              _oldActiveStream.trackIDs.find((id) => id === _audioTrack.id) &&
                console.log(`muting track with id = ${_audioTrack.id}`);
            }),
            console.log(srcObject);
          const _latestAudioTrack = srcObject
              .getAudioTracks()
              .filter((_track) => {
                if (!_oldActiveStream.trackIDs.find((id) => _track.id === id))
                  return _track;
              }),
            _latestVideoTrack = srcObject.getVideoTracks().filter((_track) => {
              if (!_oldActiveStream.vtrackIDs.find((id) => _track.id === id))
                return _track;
            }),
            _activeTracks = [_latestAudioTrack[0], _latestVideoTrack[0]];
          console.log("new stream array"), console.log(_activeTracks);
          const _newMediaStream = new MediaStream(_activeTracks);
          this.activeStreams.set(streamKey, {
            remotePeer: remotePeer,
            streamName: streamName,
            srcObject: _newMediaStream,
            trackIDs: this._getAudioTrackIDs(srcObject),
            vtrackIDs: this._getVideoTrackIDs(srcObject),
          }),
            (_newMediaStream.onactive = (event) =>
              console.log("new mediastream is now active!")),
            notify &&
              setTimeout(() => {
                this.observers.emit(
                  "updateActiveStream",
                  this.activeStreams.get(streamKey)
                );
              }, 5e3);
        } else
          console.warn(
            `LocalStore.addActiveStream: '${streamKey}' already exists!`
          );
      else
        console.log(
          `LocalStore.addActiveStream: \n    stream = ${streamName} \n    peer.clientid = ${clientid}`
        ),
          this.activeStreams.set(streamKey, {
            remotePeer: remotePeer,
            streamName: streamName,
            srcObject: srcObject,
            trackIDs: this._getAudioTrackIDs(srcObject),
            vtrackIDs: this._getVideoTrackIDs(srcObject),
          }),
          notify &&
            this.observers.emit(
              "addActiveStream",
              this.activeStreams.get(streamKey)
            );
    }),
    (this.removeActiveStream = function (remotePeer, streamName, notify = !0) {
      console.debug("removeActiveStream");
      const { clientid: clientid, features: features } = remotePeer,
        streamKey = `${clientid}${streamName}`,
        activeStream = this.activeStreams.get(streamKey);
      activeStream
        ? (notify &&
            this.observers.emit(
              "removeActiveStream",
              this.activeStreams.get(streamKey)
            ),
          activeStream.srcObject
            .getAudioTracks()
            .forEach((_track) => (_track.enabled = !0)),
          remotePeer.peerSession.send(`remove:${streamName}`),
          this.activeStreams.delete(streamKey),
          features &&
            features.availability &&
            !0 === features.availability &&
            (console.log(
              `remoteActiveStream: remotePeer (${clientid}) has availability(true). Tearing down peer session.`
            ),
            this.removePeerSession(remotePeer, !1)))
        : console.error(
            `LocalStore.removeActiveStream: '${streamKey}' not found!`
          );
    }),
    (this.getActiveStream = function (streamKey) {
      return this.activeStreams.get(streamKey);
    }),
    (this._getTransceiverReport = function (remotePeer) {
      const _transceivers = remotePeer.peerSession._pc.getTransceivers(),
        _result = { total: 0, inactive: 0, recvonly: 0, sendonly: 0 };
      return (
        _transceivers.forEach((_transceiver) => {
          switch (_transceiver.currentDirection) {
            case "inactive":
              _result.inactive++;
              break;
            case "recvonly":
              _result.recvonly++;
              break;
            case "sendonly":
              _result.sendonly++;
              break;
            default:
              console.debug(
                `_getTrasnceiverReport: Invalid currentDirection : ${_transceiver.currentDirection}`
              ),
                console.debug(_transceiver);
          }
        }),
        (_result.total = _transceivers.length),
        _result
      );
    }),
    (this.prepareStream = function (remotePeer, streamName) {
      console.log(
        "prepareStream : Check if we need to add new transceiver pair"
      );
      const _transceiverReport = this._getTransceiverReport(remotePeer);
      console.table(_transceiverReport),
        _transceiverReport.inactive >= 6
          ? console.log(
              "prepareStream : We have an available pair of inactive transceivers.  No need to add a new pair"
            )
          : (console.log(
              "prepareStream : Need to add a new pair of transceivers!"
            ),
            remotePeer.peerSession.addTransceiver("audio", {
              direction: "recvonly",
            }),
            remotePeer.peerSession.addTransceiver("video", {
              direction: "recvonly",
            }),
            remotePeer.peerSession._needsNegotiation());
    }),
    (this.playStream = function (remotePeer, streamName) {
      const { clientid: clientid, features: features } = remotePeer,
        _remotePeer = localStore.getRemotePeer(clientid);
      if (this._isPeerSessionPresent(_remotePeer))
        this._doSetupPeerTalkback(_remotePeer),
          this._doPlayStream(_remotePeer, streamName),
          console.log("remotePeer: "),
          console.log(remotePeer);
      else {
        if (
          void 0 === features ||
          void 0 === features.availability ||
          !0 !== features.availability
        )
          throw new Error(
            `playStream: remotePeer with ${clientid} no longer available.`
          );
        {
          console.log("playStream: Directly calling swCreatePeerSession!");
          const {
              peerSession: peerSession,
              streams: streams,
              ...peerInfo
            } = remotePeer,
            peerID = JSON.stringify(peerInfo);
          console.log(`playStream: peerid = ${peerID}`),
            swCreatePeerSession(
              swSignalClient,
              this.getMetaData(),
              this.getViewerOptions(),
              peerID
            )
              .then((peer) => {
                console.log("playStream: peersession established!"),
                  this.setPeerSession(remotePeer, peer),
                  this._doSetupPeerTalkback(_remotePeer),
                  this._doPlayStream(_remotePeer, streamName);
              })
              .catch((error) => {
                console.log("playStream: failed to establish p2p session!"),
                  console.error(error);
              });
        }
      }
    }),
    (this._doSetupPeerTalkback = function (remotePeer) {
      const { clientid: clientid } = remotePeer;
      if (null !== this._talkbackDummyAudioTrack)
        if (this.talkbackTransceivers.has(clientid))
          console.log(
            `_doSetupPeerTalkback: talkbackTransciever already exists for ${clientid}`
          );
        else {
          console.log(
            `_doSetupPeerTalkback: creating talkbackTransceiver for ${clientid}`
          );
          try {
            this.talkbackTransceivers.set(
              clientid,
              remotePeer.peerSession.addTransceiver(
                this._talkbackDummyAudioTrack,
                { direction: "sendonly" }
              )
            );
          } catch (error) {
            throw new Error(
              "_doSetupPeerTalkback: failed to add talkback transceiver!"
            );
          }
        }
      else
        console.log(
          "_doSetupPeerTalkback: playing stream without audio talkback."
        );
    }),
    (this._doPlayStream = function (remotePeer, streamName) {
      this.prepareStream(remotePeer, streamName),
        remotePeer.peerSession.send(`stream:${streamName}`);
    }),
    (this.findPeerByStream = function (searchName, isCloud) {
      let result = [];
      return (
        this.remotePeers.forEach((peer, key, map) => {
          if (peer.cloud == isCloud && peer.server) {
            peer.streams.find((streamName) => streamName == searchName) &&
              result.push(peer.clientid);
          }
        }),
        result
      );
    }),
    (this._resyncStream = function () {
      null !== this._audioSyncTimerID &&
        this.activeStreams.forEach((_activeStream) => {
          if (this.remotePeers.has(_activeStream.remotePeer.clientid)) {
            const _remotePeer = this.remotePeers.get(
              _activeStream.remotePeer.clientid
            );
            console.log(
              `_resyncStream : re-requesting '${_activeStream.streamName}' from remotePeer id=${_activeStream.remotePeer.clientid}`
            ),
              this.playStream(_remotePeer, _activeStream.streamName);
          } else
            console.warn(
              `_resyncStream : remotePeer id=${_activeStream.remotePeer.clientid} no longer exists!`
            );
        });
    }),
    (this.startAudioSyncher = function (interval = 36e5) {
      null === this._audioSyncTimerID
        ? ((this._audioSyncTimerID = setInterval(
            this._resyncStream.bind(this),
            interval
          )),
          console.log(`enableAudioSyncher: Enabled with interval=${interval}`))
        : console.warn(
            "enableAudioSyncher: Already enabled!  Ignoring this call."
          );
    }),
    (this.stopAudioSyncher = function () {
      null !== this._audioSyncTimerID
        ? (console.log("stopAudioSyncher: Disabled."),
          clearInterval(this._audioSyncTimerID),
          (this._audioSyncTimerID = null))
        : console.warn(
            "enableAudioSyncher: Already disabled! Ignoring this call."
          );
    }),
    (this.SwitchStream = function (fromPeer, switchParams) {
      const strSrcPeer = JSON.parse(switchParams.peerId),
        { streamName: streamName } = switchParams;
      if (
        this.remotePeers.has(fromPeer.clientid) &&
        this.remotePeers.has(strSrcPeer.clientid)
      ) {
        let oldPeer = this.remotePeers.get(fromPeer.clientid),
          newPeer = this.remotePeers.get(strSrcPeer.clientid);
        console.log(
          `LocalStore.SwitchStream:        stream=${streamName} \n       from oldPeer.clientid=${oldPeer.clientid} \n       to newPeer.clientid=${newPeer.clientid} \nnewPeer send request stream: ${streamName}`
        );
        let command = "switch";
        strSrcPeer.cloud && (command = "stream"),
          newPeer.peerSession.send(`${command}:${streamName}`),
          this.observers.emit("addSwitchStream", {
            oldPeer: oldPeer,
            newPeer: newPeer,
            streamName: streamName,
          });
      } else
        oldPeer ||
          console.error(
            `LocalStore.SwitchStream: fromPeer '${fromPeer.clientid}' not found!`
          ),
          newPeer ||
            console.error(
              `LocalStore.SwitchStream: toPeer '${strSrcPeer.clientid}' not found!`
            );
    }),
    (this._isAlreadyTalking = function (clientid, streamName) {
      if (this.talkbackCounters.has(clientid)) {
        return (
          this.talkbackCounters
            .get(clientid)
            .find((name) => name === streamName) === streamName
        );
      }
      return !1;
    }),
    (this._registerTalker = function (clientid, streamName) {
      const talkers = this.talkbackCounters.get(clientid);
      this.talkbackCounters.has(clientid)
        ? this.talkbackCounters.set(clientid, [streamName, ...talkers])
        : this.talkbackCounters.set(clientid, [streamName]);
    }),
    (this._unregisterTalker = function (clientid, streamName) {
      if (this.talkbackCounters.has(clientid)) {
        const talkers = this.talkbackCounters.get(clientid);
        this.talkbackCounters.set(
          clientid,
          talkers.filter((x) => x !== streamName)
        );
      }
    }),
    (this._canMuteTalkbackStream = function (clientid) {
      if (this.talkbackCounters.has(clientid)) {
        return 0 === this.talkbackCounters.get(clientid).length;
      }
      return !1;
    }),
    (this._isPeerSessionPresent = function (_remotePeer) {
      return (
        void 0 !== _remotePeer.peerSession && null !== _remotePeer.peerSession
      );
    }),
    (this.startTalkback = async function (
      audioTrack,
      remotePeer,
      streamName,
      isAdmin = 0
    ) {
      null !== audioTrack && this.setTalkbackAudioTrack(audioTrack);
      const { clientid: clientid } = remotePeer,
        _remotePeer = localStore.getRemotePeer(clientid);
      if (null === _remotePeer)
        throw new Error(
          `startTalkback: remotePeer with ${clientid} not found!`
        );
      if (null === this.talkbackAudioTrack)
        throw new Error("startTalkback: audioTalkback track not set!");
      if (this._isAlreadyTalking(clientid, streamName))
        return (
          console.warn(
            `startTalkback: Talkback already in progress for ${clientid} - ${streamName}`
          ),
          !1
        );
      if (!this._isPeerSessionPresent(_remotePeer))
        throw new Error(
          `startTalkback: peerSession on ${clientid} no longer available.`
        );
      return (
        _remotePeer.peerSession.send(`talkback:${isAdmin}`),
        this.talkbackWaitList.set(clientid, streamName),
        !0
      );
    }),
    (this._sendAudio = async function (clientid, streamName) {
      let mid = null;
      if (this.talkbackTransceivers.has(clientid)) {
        console.log(
          `startTalkback: Audio transceiver exists for ${clientid}. Re-enabling track on sender.`
        );
        const myTransceiver = this.talkbackTransceivers.get(clientid);
        (mid = myTransceiver.mid),
          await myTransceiver.sender.replaceTrack(this.talkbackAudioTrack);
      }
      this._registerTalker(clientid, streamName);
    }),
    (this.pushStream = async function (remotePeer, streamToPush) {
      if (!(streamToPush instanceof MediaStream))
        throw new Error(
          "pushStream: stream parameter is not a MediaStream instance!"
        );
      const { clientid: clientid } = remotePeer;
      if (null === localStore.getRemotePeer(clientid))
        throw new Error(`pushStream: remotePeer with ${clientid} not found!`);
    }),
    (this.stopTalkback = async function (remotePeer, streamName) {
      if (null === this.talkbackAudioTrack)
        throw new Error("startTalkback: audioTalkback track not set!");
      const { clientid: clientid } = remotePeer;
      if (this.talkbackTransceivers.has(clientid)) {
        if (this._isAlreadyTalking(clientid, streamName)) {
          if (
            (this._unregisterTalker(clientid, streamName),
            this._canMuteTalkbackStream(clientid))
          ) {
            console.log(
              "stopTalkback: disabling track on transceiver sender.."
            );
            const myTransceiver = this.talkbackTransceivers.get(clientid);
            await myTransceiver.sender.replaceTrack(
              this._talkbackDummyAudioTrack
            );
          }
          return (
            localStore
              .getRemotePeer(clientid)
              .peerSession.send(`stoptalkback:${streamName}`),
            !0
          );
        }
        console.warn(
          `stopTalkback: No talkback in progress for ${clientid} - ${streamName}`
        );
      } else
        console.error(
          "stopTalkback: no talkback transceiver to for this peer!"
        );
      return !1;
    }),
    (this.sendCommand = async function (remotePeer, command) {
      const { clientid: clientid } = remotePeer;
      localStore
        .getRemotePeer(clientid || remotePeer)
        .peerSession.send(`cameraCommand:${command}`);
    }),
    (this.sendConfig = async function (remotePeer, config) {
      const { clientid: clientid } = remotePeer;
      localStore
        .getRemotePeer(clientid)
        .peerSession.send(`cameraConfig:${config}`);
    }),
    (this.getStats = function (getAllStats = !1) {
      const allStats = [],
        statsPromises = [];
      return (
        this.remotePeers.forEach((remotePeer) =>
          statsPromises.push(
            (function (remotePeer) {
              return new Promise((resolve, reject) => {
                const peerStats = { clientid: remotePeer.clientid, stats: [] };
                void 0 === remotePeer.peerSession ||
                null === remotePeer.peerSession ||
                void 0 === remotePeer.peerSession._pc ||
                null === remotePeer.peerSession._pc
                  ? ((peerStats.error = `peerSession for remotePeer(${remotePeer.clientid}) is not present!`),
                    resolve(peerStats))
                  : remotePeer.peerSession._pc
                      .getStats()
                      .then((results) => {
                        results.forEach((data) => {
                          (!0 !== getAllStats &&
                            "inbound-rtp" !== data.type &&
                            "outbound-rtp" !== data.type) ||
                            peerStats.stats.push(data);
                        }),
                          resolve(peerStats);
                      })
                      .catch((error) => {
                        peerStats.error = `peerSession for remotePeer(${
                          remotePeer.clientid
                        }).  Error: ${error.toString()}`;
                      });
              });
            })(remotePeer)
          )
        ),
        new Promise((resolve, reject) => {
          Promise.all(statsPromises)
            .then((results) => {
              results.forEach((result) => {
                void 0 === result.error && allStats.push(result);
              }),
                resolve(allStats);
            })
            .catch((errors) => reject(errors));
        })
      );
    }),
    (this.startStreamMonitorX = function (interval = 1e4) {
      const _this = this,
        _statsCache = new Map();
      setInterval(() => {
        _this
          .getStats()
          .then((_remotePeers) => {
            _remotePeers.forEach((_peer) => {
              if (_peer.stats) {
                const _vidStats = _peer.stats.find(
                  (_track) => "video" === _track.kind
                );
                if (_vidStats)
                  if (_statsCache.has(_peer.clientid)) {
                    const _oldVidStats = _statsCache.get(_peer.clientid),
                      _currFramesDecoded =
                        _vidStats.framesDecoded - _oldVidStats.framesDecoded;
                    _statsCache.set(_peer.clientid, _vidStats),
                      0 === _currFramesDecoded
                        ? (console.warn(
                            `startStreamMonitor: remotePeer(${_peer.clientid}) has ${_currFramesDecoded} in the last ${interval}ms`
                          ),
                          _this.observers.emit("streamStalled", {
                            remotePeer: _peer.clientid,
                            interval: interval,
                            framesDecoded: _currFramesDecoded,
                          }))
                        : _currFramesDecoded < 0
                        ? (console.log(
                            `startStreamMonitor: remotePeer(${_peer.clientid}) previous stats are higher than newer stats.  Cached stats must be from previous streaming session.  Deleting...`
                          ),
                          _statsCache.delete(_peer.clientid))
                        : console.log(
                            `startStreamMonitor: remotePeer(${_peer.clientid}) has ${_currFramesDecoded} in the last ${interval}ms`
                          );
                  } else
                    _statsCache.set(_peer.clientid, _vidStats),
                      0 === _vidStats.framesDecoded &&
                        (console.warn(
                          `startStreamMonitor: remotePeer(${_peer.clientid}) video has less than ${_vidStats.framesDecoded} in ${interval} ms!`
                        ),
                        _this.observers.emit("streamStalled", {
                          interval: interval,
                          framesDecoded: _vidStats.framesDecoded,
                        }));
                else
                  console.warn(
                    `startStreamMonitor: remotePeer(${_peer.clientid}) has no video track!`
                  );
              } else
                console.warn(
                  `startStreamMonitor: remotePeer(${
                    _peer.clientid
                  }) has no statistics! ${JSON.stringify(_peer)}`
                );
            });
          })
          .catch((error) => {
            console.error(
              `startStreamMonitor: call to getStats() failed - ${error.message}`
            );
          });
      }, interval);
    }),
    (this.startStreamMonitor = function (interval = 1e4) {
      const _this = this,
        _statsCache = new Map();
      _this.streamMonitorId = setInterval(() => {
        _this.activeStreams.forEach((_activeStream) => {
          const _clientid = _activeStream.remotePeer.clientid,
            _remotePeer = _this.getRemotePeer(_clientid);
          _remotePeer &&
            _remotePeer.peerSession &&
            _remotePeer.peerSession._pc &&
            _remotePeer.peerSession._pc
              .getStats()
              .then((_results) =>
                _results.forEach((_stat) => {
                  if ("inbound-rtp" === _stat.type && "video" === _stat.kind) {
                    console.log(
                      `newStat.framesDecoded = ${_stat.framesDecoded}`
                    );
                    let _currentStat = null;
                    if (_statsCache.has(_clientid)) {
                      const _oldStat = _statsCache.get(_clientid);
                      _statsCache.delete(_clientid),
                        console.log(
                          `oldStat.framesDecoded = ${_oldStat.framesDecoded}`
                        ),
                        (_currentStat =
                          _stat.framesDecoded - _oldStat.framesDecoded),
                        _currentStat < 0 &&
                          (_currentStat = _stat.framesDecoded);
                    } else _currentStat = _stat.framesDecoded;
                    _statsCache.set(_clientid, _stat),
                      0 === _currentStat &&
                        _this.observers.emit("streamStalled", {
                          remotePeer: _clientid,
                          interval: interval,
                          framesDecoded: _currentStat,
                        }),
                      console.log(
                        `startStreamMonitor: peer=${_clientid}, frames decoded=${_currentStat}, interval=${interval}`
                      );
                  }
                })
              )
              .catch((_error) =>
                console.warn(
                  `startStreamMonitor : getStats() failed for clientid=${_clientid}`
                )
              );
        });
      }, interval);
    }),
    (this.reset = function () {
      (this.loggedIn = !1),
        (this.exmAddress = ""),
        (this.exmParams = {}),
        (this.metaData = {}),
        (this.viewerOptions = {}),
        (this.transceiverPairs = 0),
        this.clearActiveStreams(),
        this.clearRemotePeers(),
        (this.remotePeers = new Map()),
        (this.activeStreams = new Map()),
        (this.transceivers = new Map());
    });
}

export function swStartWebRTC(
  params,
  peerOptions = {},
  exmAddress,
  requireCloudPeer = !0
) {
  function checkCloudPeer(peer) {
    return !requireCloudPeer || peer.cloud;
  }
  console.log("swStartWebRTC"), (peerOptions.config = peerOptions.config || {});
  let socket = window.io(exmAddress);
  (swSignalClient = new window.SimpleSignalClient(socket)),
    console.log("Starting discovery sequence."),
    swSignalClient.discover(params),
    swSignalClient.on("discover", async (exmData) => {
      localStore.setPeerList([
        ...exmData.onlinePeers
          .map((e) => JSON.parse(e))
          .filter((f) => f.server),
      ]);

      if (
        (swSignalClient.socket.on("disconnect", (reason) => {
          console.warn(
            `Connection with EXM terminated. Time: ${Date.now()}. Reason: ${reason}`
          ),
            localStore.notifyDisconnectEXM(reason);
        }),
        exmData?.onlinePeers)
      )
        localStore.setLoggedIn(!0),
          exmData?.iceServers &&
            (peerOptions.config.iceServers
              ? (peerOptions.config.iceServers =
                  peerOptions.config.iceServers.concat(exmData.iceServers))
              : (peerOptions.config.iceServers = exmData.iceServers)),
          localStore.setViewerOptions(peerOptions),
          exmData.onlinePeers.forEach((peerID) => {
            if (swSignalClient.id !== peerID) {
              let remotePeer = JSON.parse(peerID);
              if (remotePeer.server) {
                if (checkCloudPeer(remotePeer)) {
                  console.log("Adding peer: "),
                    console.table(remotePeer),
                    localStore.addRemotePeer(remotePeer);
                  const { features: features } = remotePeer;
                  features &&
                  features.availability &&
                  !0 === features.availability
                    ? console.log(
                        "NOTE: remotePeer has features.availability===true!  Will not auto-peer!"
                      )
                    : swCreatePeerSession(
                        swSignalClient,
                        localStore.getMetaData(),
                        localStore.getViewerOptions(),
                        peerID
                      )
                        .then((peer) => {
                          console.log(
                            "peersession established! remotePeer ------------------------ ",
                            remotePeer
                          ),
                            localStore.setPeerSession(remotePeer, peer);
                        })
                        .catch((error) => {});
                }
                void 0 !== remotePeer.features &&
                  (console.log(
                    `notify peer feature: ${JSON.stringify(remotePeer)}`
                  ),
                  localStore.setPeerFeature(remotePeer));
              } else console.log(`Ignoring remotePeer : ${peerID}`);
            }
          }),
          console.log("Notifying online peers..."),
          swSignalClient.notify(null, swSignalClient.id, {
            type: "peeronlineEvent",
          });
      else {
        swDisconnect();
        const msg = swParseError(exmData);
        console.error(msg), alert(msg);
      }
    }),
    swSignalClient.on("request", async (request) => {
      console.warn("TODO: support the request event");
    }),
    swSignalClient.on("notify", async (source, metadata) => {
      const sourcePeer = JSON.parse(source);
      switch (metadata.type) {
        case "onlineEvent":
        case "peeronlineEvent":
          sourcePeer.server &&
            (checkCloudPeer(sourcePeer) &&
              (console.log("Adding peer: "),
              console.table(sourcePeer),
              localStore.addRemotePeer(sourcePeer),
              sourcePeer.features && sourcePeer.features.availability
                ? console.log(
                    "PEER has features.availability!  Will not auto-peer!"
                  )
                : swCreatePeerSession(
                    swSignalClient,
                    localStore.getMetaData(),
                    localStore.getViewerOptions(),
                    source
                  )
                    .then((peer) => {
                      console.log("peersession established!"),
                        localStore.setPeerSession(sourcePeer, peer);
                    })
                    .catch((error) => {})),
            void 0 !== sourcePeer.features &&
              (console.log(
                `notify peer feature: ${JSON.stringify(sourcePeer)}`
              ),
              localStore.setPeerFeature(sourcePeer)));
          break;
        case "peerofflineEvent":
          localStore.removeRemotePeer(sourcePeer);
          break;
        case "streamList":
          localStore.setStreamList(sourcePeer, metadata.streams),
            metadata.available &&
              localStore.notifyPeerAvailable(sourcePeer, metadata.available),
            metadata.talkAvailable &&
              localStore.notifyTalkbackAvailable(
                sourcePeer,
                metadata.talkAvailable
              );
          break;
        case "streamAdded":
          localStore.addStreamToList(sourcePeer, metadata.streamName);
          break;
        case "streamRemoved":
          localStore.removeStreamFromList(sourcePeer, metadata.streamName);
          break;
        case "endPeerSession":
          console.warn("TODO: endPeerSession!");
          break;
        case "peerAvailability":
          localStore.notifyPeerAvailable(sourcePeer, metadata.available);
          break;
        case "talkbackAvailability":
          localStore.notifyTalkbackAvailable(
            sourcePeer,
            metadata.talkAvailable
          );
          break;
        case "useStream":
          console.log("library : useStream! "),
            localStore.SwitchStream(sourcePeer, metadata);
          break;
        case "peerConnectionRequest":
          localStore.notifyPeerConnectionRequest(sourcePeer, metadata);
          break;
        default:
          console.warn(`Unsupported event: ${metadata.type}`);
      }
    });
}
export function swDisconnect() {
  swSignalClient?.notify(null, swSignalClient.id, {
    type: "peerofflineEvent",
  }),
    localStore.reset(),
    swSignalClient && swSignalClient.destroy(),
    localStore.setLoggedIn(!1);
}
export function swParseError(exmData) {
  return exmData?.error
    ? Array.isArray(exmData.message)
      ? exmData.message.reduce((total, item) => `${total}, ${item}`)
      : exmData.message
    : "No error";
}
export async function swCreatePeerSession(
  func,
  metadata,
  options,
  peerId = null
) {
  var peerSession = {};
  if (!peerId)
    throw (
      (console.log("Someone tried to connect but ignored..."),
      new Error("Inbound peer connections not supported"))
    );
  console.log("Connecting to peer " + peerId),
    (peerSession = (await func.connect(peerId, metadata, options)).peer);
  const parsedPeerID = JSON.parse(peerId);
  return (
    peerSession.on("connect", () => {
      swSignalClient.notify(null, swSignalClient.id, {
        type: "startPeerSession",
      }),
        localStore.notifyPeerConnected(parsedPeerID),
        console.log(
          `peerSession-connected: Connected with clientId=${parsedPeerID.clientid}`
        );
    }),
    peerSession.on("stream", (stream) => {
      console.log("Stream event received. Requested: " + stream);
    }),
    peerSession.on("track", (track, stream) => {
      if ("video" == track.kind) {
        const streamName = stream.id.split("_")[0];
        localStore.addActiveStream(parsedPeerID, streamName, stream);
      } else
        console.warn(
          `Track type = ${track.kind} is currently unsupported.  Ignoring.`
        );
    }),
    peerSession.on("data", (data) => {
      console.log(`Message from peer (${parsedPeerID.email}) : ${data}`),
        console.log("got a message from peer: " + data),
        localStore.notifyPeerData(parsedPeerID, data);
    }),
    peerSession.on("close", (data) => {
      console.log("Peer got disconnected.", data);
      JSON.parse(peerId);
    }),
    peerSession.on("error", (data) => {
      const parsedPeerID = JSON.parse(peerId);
      console.warn(`peerSession-error: clientId=${parsedPeerID.clientid}`),
        console.warn(`reason: ${JSON.stringify(data, 0, 2)}`),
        console.warn(data),
        localStore.removePeerSession(parsedPeerID);
    }),
    peerSession
  );
}
export function swRemovePeerSession(remote) {}
export async function swGetAudioCaptureDevice() {
  try {
    return (
      await navigator.mediaDevices.getUserMedia({
        video: !1,
        audio: !0,
      })
    ).getAudioTracks()[0];
  } catch (error) {
    return (
      console.error(`Failed to capture audio device: ${error.message}`), null
    );
  }
}
window.onbeforeunload = () => swDisconnect();
console.log("evoSwClient-1.0.25.systech.js");
